export default "__VITE_ASSET__Di8e2sKS__"